export const environment = {
  baseUrl: 'https://api2-dev.payee.tech/app',
  afterLoginPath: '/user',
  production: false,
  e2e: false,

  cashbook: {
    loginUrl: 'https://cashbook.io/auth/sso/payee',
  },
  ehaz: {
    loginUrl: 'https://teszt.ehaz.hu/login',
  },
  szamlazzhu: {
    url: 'https://www.devszla.hu',
  },

  HELP_URL: 'https://help.payee.tech/hu/',
};
